import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "lsat-landing" */ './LSATLandingPage'));
export const LSATSelfPacedLandingPage = Loadable(
  () => import(/* webpackChunkName: "lsat-landing" */ './LSATSelfPacedLandingPage'),
);
